import { render, staticRenderFns } from "./epms1020j.vue?vue&type=template&id=0c47fbec&scoped=true"
import script from "./epms1020j.vue?vue&type=script&lang=js"
export * from "./epms1020j.vue?vue&type=script&lang=js"
import style0 from "./epms1020j.vue?vue&type=style&index=0&id=0c47fbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47fbec",
  null
  
)

export default component.exports